import { NgModule } from '@angular/core';
import { Route, RouterModule } from '@angular/router';
import { SaleComponent } from './sale.component';
import { HomeComponent } from './views/home/home.component';
import { SaleWorkflowComponent } from './views/sale-workflow/sale-workflow.component';
import { CatalogComponent } from './views/catalog/catalog.component';
import { saleResolver } from './resolvers/sale.resolver';
import { SaleNotFoundComponent } from './views/sale-not-found/sale-not-found.component';

const routes: Route[] = [
    {
        children: [
            {
                path: 'sale/404',
                component: SaleNotFoundComponent,
            },
            {
                component: SaleWorkflowComponent,
                path: 'sale/:encoded',
                resolve: {
                    sale: saleResolver,
                },
            },
            {
                component: CatalogComponent,
                path: 'sale/catalogs/:catalog',
            },
            {
                component: HomeComponent,
                path: '',
            },
        ],
        component: SaleComponent,
        path: '',
    },
];

@NgModule({
    exports: [RouterModule],
    imports: [RouterModule.forChild(routes)],
})
export class SaleRoutesModule {
    //
}
